export const RevolutPayIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="28" height="28" rx="4" fill="black" />
      <path d="M9 9.99487H11.7194V20.6622H9V9.99487Z" fill="white" />
      <path
        d="M20.2474 10.6052C20.2474 8.34155 18.3473 6.5 16.0116 6.5H9V8.77808H15.6783C16.7353 8.77808 17.6108 9.58365 17.6302 10.5737C17.6398 11.0695 17.4481 11.5374 17.0902 11.8912C16.7321 12.2449 16.2537 12.4402 15.7431 12.4402H13.1416C13.0492 12.4402 12.974 12.5129 12.974 12.6024V14.6272C12.974 14.6617 12.985 14.6945 13.0056 14.7222L17.4195 20.6624H20.6505L16.2264 14.706C18.4544 14.5975 20.2474 12.7815 20.2474 10.6052Z"
        fill="white"
      />
    </svg>
  );
};
